var map = {
	"./checkmark.svg": "1ec3",
	"./individual.svg": "2d64",
	"./institution.svg": "05ca",
	"./key.svg": "daf4",
	"./lock.svg": "9619",
	"./nn-shield.png": "1e6d",
	"./package.svg": "d07a",
	"./warning.svg": "daa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";